import React from 'react';
import Box from '@mui/material/Box';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import { styles } from '../WorkingHours.styles';
import { ReportSite } from 'store/storeTypes';
import { KonnectAnalytics } from 'KonnectAnalytics/konnectAnalytics';

type MixedSitesBannerProps = {
  isMixed: boolean;
  selectedSites: string[];
  sites: ReportSite[];
  viewingSite: string;
  onChangeViewing: (siteId: string) => void;
};

const MixedSitesBanner = ({
  isMixed,
  selectedSites,
  sites,
  viewingSite,
  onChangeViewing,
}: MixedSitesBannerProps) => {
  if (!isMixed) return null;

  return (
    <Box sx={styles.mixedBanner}>
      <Box component="span" sx={styles.mixedBannerIcon}>
        ⚠️
      </Box>
      <Box component="span">
        <b>Selected sites have different hours.</b> Saving will unify them to the schedule shown
        below.
      </Box>
      <Box sx={styles.mixedBannerViewAs}>
        Viewing
        <Select
          size="small"
          value={viewingSite || selectedSites[0] || ''}
          onChange={e => {
            const siteId = e.target.value as string;
            onChangeViewing(siteId);
            KonnectAnalytics.productionHoursChangeViewingSite({ siteId });
          }}
          sx={styles.mixedBannerSelect}>
          {selectedSites.map(siteId => (
            <MenuItem key={siteId} value={siteId}>
              {sites.find(site => site.id === siteId)?.name ?? siteId}
            </MenuItem>
          ))}
        </Select>
      </Box>
    </Box>
  );
};

export default MixedSitesBanner;
